import type { PlaceFormValidation } from '../types'

import { useTexts } from './useTexts'

export const useComposeFieldsWithError = () => {
  const texts = useTexts()

  return (errors: PlaceFormValidation) =>
    Object.keys(errors).map(field => {
      switch (field) {
        case 'name':
          return texts.labelName
        case 'location':
          return texts.labelLocation

        default:
          return ''
      }
    })
}
